import { supabase } from "@lezz/supabase";
import React, { useState } from "react";
import { View } from "react-native";
import { logger } from "@/shared/lib/logger";
import { posthog } from "@/shared/lib/posthog";
import { unregisterPushToken } from "@/features/notifications/lib/unregister";
import { BottomSheet } from "@/shared/components/ui/bottom-sheet";
import { Button } from "@/shared/components/ui/button";
import { Heading } from "@/shared/components/ui/heading";
import { ListRow } from "@/shared/components/ui/list-row";

export function SignOutButton() {
  const [confirmVisible, setConfirmVisible] = useState(false);

  const handleConfirm = async () => {
    setConfirmVisible(false);
    posthog?.capture("user_signed_out");
    // Must run before signOut: the DELETE request needs the access token.
    await unregisterPushToken();
    const { error } = await supabase.auth.signOut();
    if (error) {
      logger.error("Sign out failed", error);
    }
  };

  return (
    <>
      <ListRow
        leadingIcon="log-out-outline"
        tone="pink"
        label="Sair"
        onPress={() => setConfirmVisible(true)}
        accessibilityLabel="Sair"
        showSeparator={false}
      />

      <BottomSheet
        visible={confirmVisible}
        onClose={() => setConfirmVisible(false)}
      >
        <Heading variant="section" className="mb-8 px-5 pt-4">
          Sair da conta?
        </Heading>
        <View className="border-border flex-row gap-3 border-t px-5 pt-4 pb-2">
          <Button
            variant="outline"
            className="flex-1"
            onPress={() => setConfirmVisible(false)}
            accessibilityLabel="Cancelar"
          >
            Cancelar
          </Button>
          <Button
            variant="destructive"
            className="flex-1"
            onPress={handleConfirm}
            accessibilityLabel="Confirmar saída"
          >
            Confirmar saída
          </Button>
        </View>
      </BottomSheet>
    </>
  );
}
